import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type ShopStaffToolbarProps = {
  canCreate: boolean;
  onCreate: () => void;
};

export function ShopStaffToolbar({
  canCreate,
  onCreate,
}: ShopStaffToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ພະນັກງານ</h2>
          <p className="text-muted-foreground text-sm">
            ເພີ່ມ/ແກ້ໄຂ ແລະ ເລືອກສາຂາ (ມາຈາກໜ້າ ສາຂາ ໄດ້) ສຳລັບ POS ແລະ ສາງ.
          </p>
        </div>
        {canCreate && (
          <Button onClick={onCreate}>
            <PlusIcon className="size-4" />
            ເພີ່ມພະນັກງານ
          </Button>
        )}
      </div>
    </div>
  );
}
